module.exports = __webpack_public_path__ + "img/bridge-width-1.37496ae.svg?v=1764903765445";